const initialState = {
  modal: null
};

export default initialState;
